import instance from "api";
import {IDynamicTableParams} from "components/DynamicTable";
import {IConsultationType} from "pages/PageConsultations/interfaces";
import {IDictionaryItem} from "components/SimpleDictionary/interfaces";

export const getDoneApplicationsList = (data: IDynamicTableParams) => {
    return instance().post("/doneResponse/list", data)
        .then(response => response.data);
}

export const getAvailableColumns = () => {
    return instance().post("/doneResponse/availableColumns")
        .then(response => response.data);
}

export const getAvailableGroupColumns = () => {
    return instance().post("/doneResponse/availableGroupColumns")
        .then(response => response.data);
}

export const addNewDoneApplication = (data: IDictionaryItem) => {
    return instance().post("/doneResponse/create",
        {doneResponseName: data.name}).then(response => response.data);
}

export const updateDoneApplication = (data: IDictionaryItem) => {
    return instance().post("/doneResponse/update",
        {doneResponseId: data.id, doneResponseName: data.name}).then(response => response.data);
}

export const deleteDoneApplication = (doneResponseId: number) => {
    return instance().post("/doneResponse/archive", {doneResponseId})
        .then(response => response.data);
}

export const recoverDoneApplication = (doneResponseId: number) => {
    return instance().post("/doneResponse/recover", {doneResponseId})
        .then(response => response.data);
}

export const getDoneApplication = (doneResponseId: number) => {
    return instance().post<IConsultationType>("/doneResponse/load", {doneResponseId})
        .then(response => response.data);
}
